import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Container, Form, FormGroup, Button, Input, Label, Row, Col, Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';

import UserCredential from '../components/user/UserCredential';
import NameInput from '../components/person/NameInput';
import * as actions from '../actions/NewUser';
import { getUser } from '../actions/User';
import * as staticDataActions from '../actions/StaticData';


class NewUser extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            roleId: '',
            showInvalidPassword: false
        };
    }


    componentDidMount() {
        const { getRoles, getGenerations, getProperTitles } = this.props.actions;
        getRoles();
        getGenerations();
        getProperTitles();
    }

    componentWillUnmount() {
        this.props.actions.clearNewUser();
    }

    handleCredentialChange = (creds) => this.setState({ ...creds });

    handleRoleChange = (e) => {
        const roleId = e.target.value;
        this.setState({ roleId });
    }

    getRoles = (roles) => {
        let options = [];
        options.push(<option key={''} value=''>Select</option>);

        roles && roles.forEach(role => {
            const { id, name } = role.toJS();
            options.push(<option key={id} value={id}>{name}</option>);
        });

        return options;
    }

    handleSave = () => {
        if (this.state.isValid)
            this.props.actions.createUser(this.state);
        else
            this.setState({ showInvalidPassword: true });

    }

    handleModalToggle = () => this.setState({ showInvalidPassword: false });

    handleNameChange = (name) => this.setState({ ...name });

    render() {
        const userId = this.props.user && this.props.user.get('id');

        if (userId) {
            this.props.actions.getUser(userId);
            this.props.history.push(`/users/user/${userId}`);
        }
        
        return (
            <Container>
                <Form>
                    <Modal isOpen={this.state.showInvalidPassword} toggle={this.handleModalToggle}>
                        <ModalHeader toggle={this.handleModalToggle}>Invalid Password</ModalHeader>
                        <ModalBody>
                            The passwords do not match.
                            </ModalBody>
                        <ModalFooter>
                            <Button color="primary" onClick={this.handleModalToggle}>Ok</Button>{' '}
                        </ModalFooter>
                    </Modal>

                    <UserCredential
                        onChange={this.handleCredentialChange}
                    />

                    <NameInput
                        properTitles={this.props.properTitles}
                        generations={this.props.generations}
                        onChange={this.handleNameChange}
                    />

                    <Row>
                        <Col>
                            <FormGroup>
                                <Label>Role:</Label>
                                <Input
                                    type='select'
                                    onChange={this.handleRoleChange}
                                    value={this.state.role}
                                >
                                    {this.getRoles(this.props.roles)}
                                </Input>
                            </FormGroup>
                        </Col>
                    </Row>


                    <Row>
                        <Col>
                            <hr />
                            <Button type="submit" className={'float-right'} onClick={this.handleSave}>Save</Button>
                        </Col>
                    </Row>
                </Form>
            </Container>
        );
    }
}


function mapStateToProps(state, ownProps) {
    return {
        roles: state.StaticData.get('roles'),
        properTitles: state.StaticData.get('properTitles'),
        generations: state.StaticData.get('generations'),
        user: state.NewUser
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators({ ...actions, ...staticDataActions, getUser }, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(NewUser);